import { Box } from "@mui/material"
import React, { useContext, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { TabEnum } from "../../../../../../components/tabs/tabs"
import { BSVariantContext } from "../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { TabPanel } from "../building/BSCalculationPage/BSCalculationForm/components/TabPanel"
import { BSBuildingDashboard } from "../tabs/BSBuildingTabs/BSBuildingDashboardTab/BSBuildingDashboard"
import { BSBuildingFondationTab } from "../tabs/BSBuildingTabs/BSBuildingFondationTab/BSBuildingFondationTab"
import { BSBuildingInfosTab } from "../tabs/BSBuildingTabs/BSBuildingInfosTab/BSBuildingInfosTab"
import { BSMorphoTab } from "../tabs/BSBuildingTabs/BSBuildingMorphologyTab/BSMorphoTab"
import { BSParkingTab } from "../tabs/BSBuildingTabs/BSBuildingParkingTab/BSParkingTab"
import { BSBuildingZoneAndLevelTab } from "../tabs/BSBuildingTabs/BSBuildingZoneAndLevelTab/BSBuildingZoneAndLevelTab"
import { BSPatioTab } from "../tabs/BSBuildingTabs/BSPatioTab/BSPatioTab"
import { BSVariantInfosTab } from "../tabs/BSVariantInfosTab/BSVariantInfos"
import { BSVariantParcelleTab } from "../tabs/BSVariantParcelleTab/BSVariantParcelleTab"
import { BSVariantControlPanelProvider } from "./BSVariantControlPanelContext"
import { BSVariantSideNavBar } from "./BSVariantSideNavBar/BSVariantSideNavBar"
import { WarningUpdatedDialogContext, WarningUpdatedDialogContextProvider } from "./Dialog/WarningUpdatedDialogContext"

export function BSVariantControlPanel(): React.JSX.Element {
  return (
    <BSVariantControlPanelProvider>
      <WarningUpdatedDialogContextProvider>
        <BSVariantControlPanelCore />
      </WarningUpdatedDialogContextProvider>
    </BSVariantControlPanelProvider>
  )
}

function BSVariantControlPanelCore(): React.JSX.Element {
  const [searchParams] = useSearchParams()

  const { selectedVariant } = useContext(BSVariantContext)
  const { isUpdating, setIsUpdating, selectedTab, setSelectedTab } = useContext(WarningUpdatedDialogContext)

  const [openVariantSideNavBar, setOpenVariantSideNavBar] = useState<boolean>(true)
  const [variantDrawerWidth, setVariantDrawerWidth] = useState<number>(0)

  useEffect(() => {
    const tab = searchParams.get("tab")
    if (tab) {
      setSelectedTab(Number(tab))
    }
  }, [searchParams, setSelectedTab])

  return (
    <>
      <BSVariantSideNavBar
        openVariantSideNavBar={openVariantSideNavBar}
        setOpenVariantSideNavBar={setOpenVariantSideNavBar}
        variantDrawerWidth={variantDrawerWidth}
        setVariantDrawerWidth={setVariantDrawerWidth}
      />

      <Box
        height="100%"
        pt={1}
        sx={{
          width: `calc(100% - ${variantDrawerWidth}px)`,
          marginLeft: `${variantDrawerWidth}px`,
          zIndex: 1200,
        }}>
        {/* For now we keep tab panel because it allows to keep components mounted */}
        {/* If we see that its becoming slow, we can adjust with a switch */}

        {/* Main section */}
        <TabPanel selectedTab={selectedTab} index={TabEnum.BS_VARIANT_DASHBOARD} />
        <TabPanel selectedTab={selectedTab} index={TabEnum.BS_VARIANT_INFO}>
          <BSVariantInfosTab bsVariant={selectedVariant} setIsUpdating={setIsUpdating} isUpdating={isUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BS_VARIANT_PARCELLE}>
          <BSVariantParcelleTab bsVariant={selectedVariant} setIsUpdating={setIsUpdating} isUpdating={isUpdating} />
        </TabPanel>

        {/* Building section */}
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_DASHBOARD}>
          <BSBuildingDashboard />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_INFO}>
          <BSBuildingInfosTab setSelectedTab={setSelectedTab} setIsUpdating={setIsUpdating} isUpdating={isUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_MORPHOLOGY_OR_BIM}>
          <BSMorphoTab isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_LEVEL}>
          <BSBuildingZoneAndLevelTab setSelectedTab={setSelectedTab} setIsUpdating={setIsUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_PATIO}>
          <BSPatioTab setIsUpdating={setIsUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_FONDATIONS}>
          <BSBuildingFondationTab isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
        </TabPanel>
        <TabPanel selectedTab={selectedTab} index={TabEnum.BUILDING_PARKING}>
          <BSParkingTab isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
        </TabPanel>
      </Box>
    </>
  )
}
